import { TallFiltersCont, theme } from "../../Styles";
import { CONTRACT_NAME } from "../config";
import { Table, TableData, TableHeader, TableRow, TokenCheckbox } from "../css/ListingPageStyles";
import { buildCollectionUrl, buildSchemaUrl, buildTemplateUrl } from "./global_functions";
import { getAssetQuantity, getAssetSymbol, getPrecisionFromAsset, getWalletSession } from "./wallet_functions";

export const showOpText = (op, quantity) => {
    if(Number(op) === 0){
        return <h2><span style={{color: theme.secondary}}>Any {quantity}</span> of the following are required:</h2>
    }
    if(Number(op) === 1){
        return <h2><span style={{color: theme.secondary}}>All</span> of the following are required:</h2>
    }    
}

export const isInUse = (asset_id, listing_index, assetVector, whitelistVector, currentVector) => {
    const isInOtherVector = currentVector === "asset" ? whitelistVector.some(asset => asset.asset_id === asset_id) : assetVector.some(asset => asset.asset_id === asset_id)

    const hasDifferentListingIndexInSameVector = currentVector === "asset" ? assetVector.some(
        asset => asset.asset_id === asset_id && asset.listing_index !== listing_index
    ) :  whitelistVector.some(
        asset => asset.asset_id === asset_id && asset.listing_index !== listing_index
    )

    return hasDifferentListingIndexInSameVector || isInOtherVector;
};

export const listingRequirementsAreMet = (listingData, assetVector, whitelistVector, tokenVector) => {
    //what do we need?
    /**
     *  listing data
     *  selected proof nfts (whitelist vector)
     *  selected payment nfts (asset vector)
     *  fungible token balances
     */

    //if there are any fungible tokens, loop and make sure we meet the reqs
    if(listingData.fungible_prices.prices.length > 0){
        let tokens_satisfied = 0;
        for(let p of listingData.fungible_prices.prices){
            for(let token of tokenVector) {
                const [tokenQuantity, tokenSymbol] = token.quantity.split(' ');
                const [priceQuantity, priceSymbol] = p.quantity.split(' ');

                if(token.contract === p.contract && tokenSymbol === priceSymbol && parseFloat(tokenQuantity) >= parseFloat(priceQuantity)) {
                    tokens_satisfied++;
                }
            }
        }
        if(listingData.fungible_prices.op === 0){//any x of
            if(tokens_satisfied < listingData.fungible_prices.quantity){
                return false;
            }
        }
        else{//all of
            if(tokens_satisfied < listingData.fungible_prices.prices.length){
                return false;
            }
        }        

    }




    return true;
}

export const showNftIngredientTitle = (ingredient) => {
    let i = ingredient;

    if(i.filter_by === 0){ //collection
        return <TallFiltersCont>
            <h2>{i.quantity} NFT{i.quantity > 1 && "s"} from <a href={buildCollectionUrl(i.collection_name)} target="none">{i.collection_name}</a> collection</h2>
        </TallFiltersCont>
    }

    else if(i.filter_by === 1){ //schema
      return <TallFiltersCont>
          <h2>{i.quantity} NFT{i.quantity > 1 && "s"} from <a href={buildCollectionUrl(i.collection_name)} target="none">{i.collection_name}</a> collection, using <a href={buildSchemaUrl(i.collection_name, i.schema_name)} target="none">{i.schema_name}</a> schema</h2>
      </TallFiltersCont>
  }    

  else if(i.filter_by === 2){ //template
    return <TallFiltersCont>
        <h2>{i.quantity} NFT{i.quantity > 1 && "s"} from <a href={buildCollectionUrl(i.collection_name)} target="none">{i.collection_name}</a> collection, using template ID #<a href={buildTemplateUrl(i.collection_name, i.template_id)} target="none">{i.template_id}</a></h2>
    </TallFiltersCont>
}      
}

export const showFungibleIngredientTable = (tokens, tokenVector, setTokenVector, max_discount_percent, satisfiedNfts, nft_prices) => {

    const handleCheckboxChange = (token) => {
        if(tokenVector.some(t => t.contract === token.contract && t.quantity === token.quantity)) {
            setTokenVector(tokenVector.filter(t => !(t.contract === token.contract && t.quantity === token.quantity)));
        } else {
            setTokenVector([...tokenVector, token]);
        }
    };

    return <span>
    <br />
    <Table>
      <thead>
        <TableRow>
        <TableHeader>Select</TableHeader>
          <TableHeader>Amount</TableHeader>
          <TableHeader>Contract</TableHeader>
        </TableRow>
      </thead>
      <tbody>
        {tokens.map((token, index) => (
          <TableRow key={index}>
            <TableData>
                <TokenCheckbox
                    onClick={() => {
                      handleCheckboxChange(token);
                    }}
                    selected={tokenVector.some(t => t.contract === token.contract && t.quantity === token.quantity) ? "yes" : "no"}
                    >
                        {tokenVector.some(t => t.contract === token.contract && t.quantity === token.quantity) && (<span>&#x2713;</span>)}
                    </TokenCheckbox>
            </TableData>            
            <TableData>{Number(getAssetQuantity(token.quantity)) - (Number(getAssetQuantity(token.quantity)) * Number(Number(get_total_discount(max_discount_percent, satisfiedNfts, nft_prices)))).toFixed(Number(getPrecisionFromAsset(token.quantity))) + " " + getAssetSymbol(token.quantity)}</TableData>
            <TableData>{token.contract}</TableData>

          </TableRow>
        ))}
      </tbody>
    </Table>
  </span>
}

export const buyListing = async (listing_id, subdomain, suffix, fungible_ingredients, proof_nfts, nft_prices, active_public_key, owner_public_key, setEnterModalText, setLoadingDisplay, setEnterButtonsDisplay, setEnterModalDisplay, total_discount) => {
    setEnterModalDisplay('');
    setEnterModalText('Awaiting confirmation...');
    let walletSession = await getWalletSession(setEnterModalText);
    let session = walletSession[0];
    let this_user = walletSession[1];
    let this_permission = walletSession[2];


    try {   
      for(let f of fungible_ingredients){
        let amount = Number(getAssetQuantity(f.quantity)) - (Number(getAssetQuantity(f.quantity)) * Number(total_discount));
        let amount_as_asset = amount.toFixed(Number(getPrecisionFromAsset(f.quantity))) + " " + getAssetSymbol(f.quantity);
        f.quantity = amount_as_asset;        
      }

      
      let actions = [
        {
            account: CONTRACT_NAME,
            name: "assertorder",
            authorization: [
              {
                actor: this_user,
                permission: this_permission,
              },
            ],
            data: {
                buyer: this_user, 
                listing_id: listing_id,
                subdomain: subdomain,
                fungible_ingredients: fungible_ingredients,
                proof_nfts: proof_nfts,
                nft_prices: nft_prices,
                active_public_key: active_public_key,
                owner_public_key: owner_public_key,
            },
          },
      ]
      for(let f of fungible_ingredients){

        actions.push({
            account: f.contract,
            name: "transfer",
            authorization: [
                {
                  actor: this_user,
                  permission: this_permission,
                },
              ],
              data: {
                from: this_user, 
                to: CONTRACT_NAME,
                quantity: f.quantity,
                memo: "|add_ingredient|" + listing_id + "|" + subdomain + "|" + suffix + "|"
            },                          
        })
    }

    if(nft_prices.length >= 1){
        let assets = [];
        for(let p of nft_prices){
            assets.push(p.asset_id)
        }

        actions.push({
            account: "atomicassets",
            name: "transfer",
            authorization: [
                {
                  actor: this_user,
                  permission: this_permission,
                },
              ],
              data: {
                from: this_user, 
                to: CONTRACT_NAME,
                asset_ids: assets,
                memo: "|add_ingredient|" + listing_id + "|" + subdomain + "|" + suffix + "|"
            },                          
        })
    }    


      const response = await session[0].signTransaction({
        actions: actions
      }, {
  
        blocksBehind: 3,
        expireSeconds: 1200,
        broadcast: true,
      })
      setLoadingDisplay('');
      setEnterButtonsDisplay('hidden');
      setEnterModalText('Processing your transaction...')
      const timer = setTimeout(() => {
        
          setEnterModalText('Your custom name has been created!');
          setLoadingDisplay('none');
          setEnterButtonsDisplay('');
    
      }, 1000);
      return () => clearTimeout(timer);
  
    } catch(e) {
      setEnterModalText(JSON.stringify(e.message));
      console.log(e)
      
    }
 
  }

export const handle_satisfied_update = (index, vector, setVector, isMet) => {
  const existing = [...vector];

  if(isMet){
    //add it if necessary
    if(existing.indexOf(index) == -1){
      existing.push(index);
      setVector(existing);
    }    
  } else {
    //remove it if necessary
    if(existing.indexOf(index) > -1){
      existing.splice(existing.indexOf(index), 1);
      setVector(existing);
    }    
  }

  console.log("existing: " + existing);
}  


export const requirement_is_met = (requirementType, requirementIndex, satisfiedFungibles, 
  setSatisfiedFungibles, satisfiedNfts, setSatisfiedNfts, satisfiedWhitelists, setSatisfiedWhitelists, 
  fungible_requirements, nft_requirements, whitelist_requirements, max_discount_percent, 
  discountAppied, setDiscountApplied, tokenVector, assetVector, whitelistVector) => 
{

/**
 *  this is for a specific requirement, not for a whole category
 *  maybe fungibles should be removed from this and moved to a different function
 *  the point of this function was mainly to apply discounts, and to prevent people from selecting 
 *  too many NFTs for 1 requirement
 */

  let index = requirementIndex;
  let isMet = false;
  let satisfiedVector;
  let setSatisfiedVector;

  if(requirementType == "fungible"){
    satisfiedVector = satisfiedFungibles;
    setSatisfiedVector = setSatisfiedFungibles;
    let tokens = fungible_requirements;

    if(tokens.op == 0){//any x of
      if(tokenVector.length >= tokens.quantity){        
        isMet = true;
      }
    }

    else if(tokens.op == 1){//all of
      if(tokenVector.length >= tokens.prices.length){        
        isMet = true;
      }
    }

  }

  else if(requirementType == "nft_price"){
    satisfiedVector = satisfiedNfts;
    setSatisfiedVector = setSatisfiedNfts;    
    let prices = nft_requirements.prices;
    let index_matches = 0;

    for(let a of assetVector){
      if(a.listing_index == index){
        index_matches ++;
        if(index_matches >= prices[index].quantity){        
          isMet = true;
          break;
        }
      }
    }
  }

  else if(requirementType == "whitelist"){
    satisfiedVector = satisfiedWhitelists;
    setSatisfiedVector = setSatisfiedWhitelists;    
    let prices = whitelist_requirements;
    let index_matches = 0;

    for(let w of whitelistVector){
      if(w.listing_index == index){
        index_matches ++;
        if(index_matches >= prices[index].quantity){          
          isMet = true;
          break;
        }
      }
    }
  }

  handle_satisfied_update(index, satisfiedVector, setSatisfiedVector, isMet)
  return isMet;

}

export const get_total_discount = (max_discount, satisfied_nft_indexes, nft_prices) => {
  if(max_discount == 0){
    return 0;
  }

  let total_discount = 0;

  for(let s of satisfied_nft_indexes){
    console.log("s: " + s)
    console.log(nft_prices)
    total_discount += Number(nft_prices[s].discount_percent);
  }

  if(total_discount > Number(max_discount)){
    return Number(max_discount);
  }
  return total_discount;
}

export const handleNameToCheckChange = (event, setNameToCheck) => {
  const newValue = event.target.value;

  if (newValue === '' || /^[a-z1-5]*$/.test(newValue)) {
      setNameToCheck(newValue);
  }
}